module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Wind-d28d0b76f42fa57c88893f164abbb3bf.svg";